(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this._mql = window.matchMedia('(min-width: 750px)');
      this._onModeChange = this._onModeChange.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      if (this._mql.addEventListener) {
        this._mql.addEventListener('change', this._onModeChange);
      } else if (this._mql.addListener) {
        this._mql.addListener(this._onModeChange);
      }

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);

      this._syncMode();
    }

    disconnectedCallback() {
      if (this._mql) {
        if (this._mql.removeEventListener) {
          this._mql.removeEventListener('change', this._onModeChange);
        } else if (this._mql.removeListener) {
          this._mql.removeListener(this._onModeChange);
        }
      }
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
    }

    _onModeChange() {
      this._syncMode();
    }

    _syncMode() {
      const desktop = this._mql.matches;
      this.dataset.mode = desktop ? 'tabs' : 'accordion';
      const panels = this.querySelectorAll('.product-tabs__panel');
      if (desktop) {
        let active = null;
        const tabs = this.querySelectorAll('[role="tab"]');
        tabs.forEach((t) => {
          if (t.getAttribute('aria-selected') === 'true') active = t.dataset.target;
        });
        if (!active && tabs[0]) active = tabs[0].dataset.target;
        panels.forEach((panel) => {
          const details = panel.querySelector('details');
          if (!details) return;
          details.open = panel.dataset.panel === active;
        });
      }
    }

    _onClick(e) {
      if (!this._mql.matches) return;
      const tab = e.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;
      e.preventDefault();
      this._activate(tab);
    }

    _onKeydown(e) {
      if (!this._mql.matches) return;
      const tab = e.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const idx = tabs.indexOf(tab);
      let next = null;
      switch (e.key) {
        case 'ArrowRight':
          next = tabs[(idx + 1) % tabs.length];
          break;
        case 'ArrowLeft':
          next = tabs[(idx - 1 + tabs.length) % tabs.length];
          break;
        case 'Home':
          next = tabs[0];
          break;
        case 'End':
          next = tabs[tabs.length - 1];
          break;
      }
      if (next) {
        e.preventDefault();
        this._activate(next);
        next.focus();
      }
    }

    _activate(tab) {
      const id = tab.dataset.target;
      this.querySelectorAll('[role="tab"]').forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('.product-tabs__panel').forEach((panel) => {
        const details = panel.querySelector('details');
        if (!details) return;
        details.open = panel.dataset.panel === id;
      });
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
